import React, { useEffect, useRef } from 'react';
import { MarcaConfiguracionInicial } from './MarcaConfiguracionInicial';
import '../../../Commons/Scripts/Componentes/Loader/processing.css';

const etapas = ['Comprobar respuestas', 'Aplicar configuración', 'Confirmar resultado'];

export const ProcesandoConfiguracionInicial = ({ fase }) => {
  const titulo = useRef(null);
  useEffect(() => { titulo.current?.focus(); }, []);
  const cargando = !fase;
  const paso = fase?.startsWith('Confirmando') ? 2 : fase?.startsWith('Comprobando') ? 0 : 1;
  const porcentaje = Math.round(paso * 100 / etapas.length);
  return <div className="ci-result-screen ci-processing-screen" role="main" aria-busy="true">
    <header className="ci-result-header"><MarcaConfiguracionInicial /><span>Configuración inicial</span></header>
    <div className="ci-result-body">
      <section className="processing-card ci-processing-card" aria-labelledby="ci-processing-title">
        <div className="processing-orange-wrap" aria-hidden="true">
          <img className="processing-orange" src="/Commons/Scripts/Componentes/Formalizar/prototype/wizard/assets/images/citrus-processing-orange.png" alt="" />
        </div>
        <h1 id="ci-processing-title" ref={titulo} tabIndex="-1">{cargando ? 'Preparando tu asistente' : 'Configurando tu empresa'}</h1>
        <p className="ci-processing-status" role="status" aria-live="polite" aria-atomic="true">{fase || 'Cargando tus respuestas y el progreso de tu configuración.'}</p>
        <div className={`processing-progress${cargando ? ' ci-progress-indeterminate' : ''}`} role="progressbar"
          aria-label={cargando ? 'Carga del asistente' : 'Etapas de configuración'} aria-valuemin="0" aria-valuemax="100"
          aria-valuenow={cargando ? undefined : porcentaje} aria-valuetext={cargando ? 'Cargando' : `Paso ${paso + 1} de 3: ${etapas[paso]}`}>
          <div className="processing-progress__bar" style={{ width: cargando ? '100%' : `${porcentaje}%` }} />
        </div>
        {!cargando && <><div className="ci-processing-step">Paso {paso + 1} de 3</div>
          <ol className="ci-processing-stages">{etapas.map((etapa, i) => <li key={etapa} className={i < paso ? 'is-done' : i === paso ? 'is-current' : ''} aria-current={i === paso ? 'step' : undefined}>
            <span aria-hidden="true">{i < paso ? '✓' : i + 1}</span>{etapa}
          </li>)}</ol></>}
        <p className="processing-note">{cargando ? 'En un momento podrás continuar.' : 'Mantén esta ventana abierta hasta que confirmemos el resultado.'}</p>
      </section>
    </div>
  </div>;
};

export const ConfiguracionInicialCompletada = ({ onContinuar, soloPlan = false }) => {
  const titulo = useRef(null);
  useEffect(() => { titulo.current?.focus(); }, []);
  return <div className="ci-result-screen" role="main">
    <header className="ci-result-header"><MarcaConfiguracionInicial /><span>Configuración inicial</span></header>
    <div className="ci-result-body">
      <section className="ci-completion-card" aria-labelledby="ci-completion-title">
        <div className="ci-completion-seal" aria-hidden="true"><svg viewBox="0 0 48 48" fill="none"><path d="m13 24 7 7 15-15" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" /></svg></div>
        <span className="ci-completion-eyebrow">Un buen comienzo para tu negocio</span>
        <h1 id="ci-completion-title" ref={titulo} tabIndex="-1">{soloPlan ? 'Tu asistente está completado' : '¡Configuración inicial completada!'}</h1>
        <p className="ci-completion-lead">{soloPlan ? 'Tus respuestas y tu plan de configuración quedaron guardados.' : 'Terminaste el asistente de configuración de tu empresa. Ya puedes continuar en tu cuenta.'}</p>
        <div className="ci-completion-next"><strong>Tu configuración puede crecer contigo</strong><p>Cuando lo necesites, puedes revisar y ajustar estos datos desde cada sección de tu cuenta.</p></div>
        <button type="button" className="btn ci-button ci-button--continue" onClick={onContinuar}>Volver al ERP <span aria-hidden="true">→</span></button>
        {soloPlan && <p className="ci-completion-footnote">El plan está guardado; esta modalidad no aplica cambios.</p>}
      </section>
    </div>
  </div>;
};
